// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__SvJpt","savePackageButton":"ClientWallet_savePackageButton__YGuEt"};